import type { TaskPriority } from './datetime';

/** Порядок приоритетов: urgent > high > medium > low. */
export const PRIORITY_ORDER = ['urgent', 'high', 'medium', 'low'] as const;

export type PriorityValue = (typeof PRIORITY_ORDER)[number];

/** Русские подписи приоритетов в интерфейсе. */
export const PRIORITY_UI_LABEL: Record<TaskPriority, string> = {
  urgent: 'очень срочно!',
  high: 'срочно',
  medium: 'терпит',
  low: 'не срочно',
};

/** Ранг сортировки: меньше = выше в списке. */
export const PRIORITY_RANK: Record<TaskPriority, number> = {
  urgent: 0,
  high: 1,
  medium: 2,
  low: 3,
};

export function isTaskPriority(value: unknown): value is TaskPriority {
  return value === 'urgent' || value === 'high' || value === 'medium' || value === 'low';
}

export function priorityLabel(priority: TaskPriority): string {
  return PRIORITY_UI_LABEL[priority];
}

/** Полоска строки слева. */
export const PRIORITY_BAR_CLASS: Record<TaskPriority, string> = {
  urgent: 'border-l-[5px] border-tg-priority-urgent tg-urgent-bar',
  high: 'border-l-4 border-tg-priority-high',
  medium: 'border-l-[3px] border-tg-priority-medium',
  low: 'border-l-2 border-tg-priority-low',
};

/** Цвет маркера/точки приоритета (календарь, фильтры). */
export const PRIORITY_DOT_CLASS: Record<TaskPriority, string> = {
  urgent: 'bg-tg-priority-urgent',
  high: 'bg-tg-priority-high',
  medium: 'bg-tg-priority-medium',
  low: 'bg-tg-priority-low',
};
